import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

interface LegacyPageRedirectProps {
  /** Builds the target path from the route's `:id` param (when there is one). */
  to: (id?: string) => string
}

/**
 * Pagination used to live in the path (/authors/3, /authors/7/questions/2).
 * It now lives in the query string (?page=N), so old links, bookmarks and
 * indexed URLs are redirected to the new shape instead of silently
 * rendering page 1.
 */
const LegacyPageRedirect: React.FC<LegacyPageRedirectProps> = ({ to }) => {
  const { id, page } = useParams<{ id?: string; page?: string }>()

  const parsed = parseInt(page || '1', 10)
  const search = !Number.isNaN(parsed) && parsed > 1 ? `?page=${parsed}` : ''

  return <Navigate to={`${to(id)}${search}`} replace />
}

export default LegacyPageRedirect
